<template>
  <form v-if="isLoaded" @submit.prevent="submit" @reset.prevent="reset" v-cloak class="b-filter" method="POST">

    <div v-if="debug" style="position: absolute; right: -250px; top: 20px;">
      <pre>{{ fData }}</pre>
    </div>




    <div id="tooltipContent" @mouseover="tooltipHide(true)" @mouseleave="tooltipHide(false)">
      Найдено: {{ countResults }}
      <br>
      <button type="submit" class="button button--wayra fg-white" v-if="countResults" @click="submit()">
        Показать
      </button>
    </div>

    <hint :isShow="tooltipVisibility">
      <template slot="content">

        <span v-tooltip.notrigger="{ html: 'tooltipContent', visible: tooltipVisibility, delay: 1000 }">
          <!-- {{ tooltipVisibility }} -->
        </span>

      </template>
    </hint>


    <!-- Продажа Аренда  -->
    <div class="deal-types" v-show="
    filterMode == 'horizontal' ||
    (
      fData.estate_group != constants.build &&
      !in_array(fData.estate_type, [constants.complex, constants.village, constants.land, constants.commerce_land])
    )
    ">
      <radio ref="deal_type" v-for="item in defaults.deal_type" :value="item.id" :label="item.text" :key="item.key" v-model="fData.deal_type"></radio>
    </div>
    <!-- NOTE: for computed -->
    <pre v-show="false">
      {{ _price }}
      {{ _price_hs }}
      {{ _price_sq }}
    </pre>
    <pre v-show="false">
      {{ _sliderOpts }}
      {{ _hs_sliderOpts }}
      {{ _sq_sliderOpts }}
    </pre>

    <div class="b-filter__wrapper">
      <div class="grid-x b-filter__controls gap">



        <!-- Вид недвижимости -->
        <div class="cell"
            :class="{'xlarge-3 medium-6': filterMode == 'horizontal'}"
            v-show="filterMode == 'horizontal'"
          >
          <label>
            <span class="show-for-xlarge"
                :class="{'hide': filterMode == 'vertical'}"
              >&nbsp;</span>
          </label>
          <select2
              ref="estate_group"
              :options="dealFilterToPropertyKind(defaults.estate_group)"
              dependent="defaults.estate_type"
              v-model="fData.estate_group"
              data-theme="dk"
              data-minimum-results-for-search="Infinity"
            >
          </select2>
        </div>




        <div class="cell small-order-5" v-if="filterMode == 'vertical'"><hr></div>

        <!-- Населенный пункт -->
        <div class="cell"
            :class="{'xlarge-3 medium-6': filterMode == 'horizontal', 'small-order-6': filterMode == 'vertical'}"
          >
          <label>
            <span class="show-for-xlarge"
                :class="{'hide': filterMode == 'vertical'}"
              >&nbsp;</span>
          </label>

          <!-- <select2
              ref="locality" multiple
              :options="defaults.locality"
              v-model="fData.locality"
              data-theme="dkm" data-close-on-select="false"
              data-placeholder="Не важно..."
              data-minimum-results-for-search="Infinity"
              @change="fetchLocalityData"
            >
          </select2> -->

          <select2
              ref="locality"
              :options="defaults.locality"
              v-model="fData.locality"
              data-theme="dk"
              data-minimum-results-for-search="Infinity"
              @change="fetchLocalityData"
            >
          </select2>
        </div>



        <!-- Район, метро, улица -->
        <div class="cell"
            :class="{'xlarge-6 medium-12': filterMode == 'horizontal', 'small-order-5': filterMode == 'vertical'}"
          >
          <label>
            <!-- geo -->
            <span class="show-for-xlarge"
                :class="{'hide': filterMode == 'vertical'}"
              >&nbsp;</span>
          </label>
          <geo
            ref="geo"
            v-model="fData.geo"
            :placeholder="geoPlaceholder"
            :lists="geoLists"
            v-if="localityDataIsLoaded"></geo>
        </div>



        <!-- filterMode == 'vertical' этажность -->
        <div class="grid-x cell small-order-6" v-if="filterMode == 'vertical'">
          <portal-target v-if="filterMode == 'vertical'" name="vertical_floor" slim ></portal-target>
          <div class="hyphen cell shrink invisible"
            v-if="
                  filterMode == 'vertical' &&
                  in_array(fData.estate_group, [constants.ready]) &&
                  fData.estate_type != constants.complex
                ">&nbsp;-&nbsp;</div>
          <portal-target v-if="filterMode == 'vertical'" name="vertical_storeys" slim ></portal-target>
        </div>



        <!-- Тип недвижимости -->
        <div class="cell"
            :class="{'xlarge-3 medium-6': filterMode == 'horizontal', 'small-order-1': filterMode == 'vertical'}"
          >
          <label v-if="fData.estate_group == constants.commerce"><!-- Тип использования -->Что ищу</label>
          <label v-else><!-- Тип недвижимости -->Что ищу</label>
          <select2
              ref="estate_type"
              :options="dealFilterToPropertyType(defaults.estate_type[fData.estate_group])"
              dependon="defaults.estate_group"
              v-model="fData.estate_type"
              data-theme="dk"
              data-minimum-results-for-search="Infinity"
            >
          </select2>
        </div>



        <!-- Количество комнат -->
        <div class="cell"
            :class="{'xlarge-3 medium-6': filterMode == 'horizontal', 'small-order-3': filterMode == 'vertical'}"
            v-if="fData.estate_group != constants.commerce && fData.estate_type != constants.land"
          >
          <label>Количество комнат</label>
          <div class="b-qrooms">
            <rooms
                ref="apartment_room"
                v-for="item in ((fData.estate_group != constants.cottage) ? defaults.apartment_room : defaults.cottage_room)"
                :value="item.id"
                :label="item.text"
                :key="item.key"
                v-model="fData.apartment_room"
              ></rooms>
          </div>
        </div>



        <!-- Общая площадь -->
        <div class="cell"
            :class="{'xlarge-3 medium-6': filterMode == 'horizontal', 'small-order-4': filterMode == 'vertical'}"
            v-if="fData.estate_type != constants.commerce_land"
          >
          <label>Общая площадь, м²</label>
          <fromto ref="total_area" v-model="fData.total_area"></fromto>
        </div>



        <!-- Общая площадь, сотки -->
        <div class="cell"
            :class="{'xlarge-3 medium-6': filterMode == 'horizontal', 'small-order-3': filterMode == 'vertical'}"
            v-if="fData.estate_type == constants.commerce_land"
          >
          <label>Общая площадь, сотки</label>
          <fromto ref="total_area_hs" v-model="fData.total_area_hs"></fromto>
        </div>



        <!-- SLIDER && fData.deal_type == constants.sale -->
        <div class="cell small-order-2" v-if="filterMode == 'vertical'">
          <label>Цена (руб)</label>
          <div class="grid-x align-middle" ref="price">
            <div class="cell auto"><money :min="_sliderOpts.min" :max="fData.price[1]" v-model="fData.price[0]"></money></div>
            <div class="hyphen shrink">&nbsp;-&nbsp;</div>
            <div class="cell auto"><money :min="fData.price[0]" :max="_sliderOpts.max" v-model="fData.price[1]"></money></div>
          </div>
          <vue-slider v-bind="_sliderOpts" v-model="fData.price"></vue-slider>
        </div>



        <!-- Цена -->
        <!-- <div class="cell" :class="{'xlarge-3 medium-6': filterMode == 'horizontal'}" v-if="filterMode == 'horizontal'">
          <label>Цена (руб)</label>
          <div class="grid-x align-middle" ref="price">
            <div class="cell auto"><money v-model="fData.price[0]"></money></div>
            <div class="hyphen shrink">&nbsp;-&nbsp;</div>
            <div class="cell auto"><money v-model="fData.price[1]"></money></div>
          </div>
        </div> -->
        <div class="cell" :class="{'xlarge-3 medium-6': filterMode == 'horizontal'}" v-if="filterMode == 'horizontal'">
          <label>Цена (руб)</label>
          <div class="grid-x align-middle" ref="price">
            <div class="cell auto"><money v-model="fData.price[0]"></money></div>
            <div class="hyphen shrink">&nbsp;-&nbsp;</div>
            <div class="cell auto"><money v-model="fData.price[1]"></money></div>
          </div>
        </div>



        <!-- SLIDER -->
        <div class="cell small-order-2" v-if="fData.estate_group == constants.commerce &&
          fData.estate_type != constants.commerce_land && filterMode == 'vertical'">
          <label>Цена за кв м. (руб)</label>
          <div class="grid-x align-middle" ref="price_sq">
            <div class="cell auto"><money :min="_sq_sliderOpts.min" :max="fData.price_sq[1]" v-model="fData.price_sq[0]"></money></div>
            <div class="hyphen shrink">&nbsp;-&nbsp;</div>
            <div class="cell auto"><money :min="fData.price_sq[0]" :max="_sq_sliderOpts.max" v-model="fData.price_sq[1]"></money></div>
          </div>
          <vue-slider v-bind="_sq_sliderOpts" v-model="fData.price_sq"></vue-slider>
        </div>



        <!-- Цена за кв м. (руб) -->
        <div class="cell" :class="{'xlarge-3 medium-6': filterMode == 'horizontal'}"
          v-if="fData.estate_group == constants.commerce &&
          fData.estate_type != constants.commerce_land && filterMode == 'horizontal'"
        >
          <label>Цена за кв м. (руб)</label>
          <div class="grid-x align-middle" ref="price_sq">
            <div class="cell auto"><money v-model="fData.price_sq[0]"></money></div>
            <div class="hyphen shrink">&nbsp;-&nbsp;</div>
            <div class="cell auto"><money v-model="fData.price_sq[1]"></money></div>
          </div>
        </div>



        <!-- SLIDER -->
        <div class="cell small-order-2"
          v-if="((fData.estate_type == constants.commerce_land &&
          fData.deal_type == constants.sale) || fData.estate_type == constants.land) &&
          filterMode == 'vertical'
          ">
          <label>Цена за сотку (руб)</label>
          <div class="grid-x align-middle" ref="price_hs">
            <div class="cell auto"><money :min="_hs_sliderOpts.min" :max="fData.price_hs[1]" v-model="fData.price_hs[0]"></money></div>
            <div class="hyphen shrink">&nbsp;-&nbsp;</div>
            <div class="cell auto"><money :min="fData.price_hs[0]" :max="_hs_sliderOpts.max" v-model="fData.price_hs[1]"></money></div>
          </div>
          <vue-slider v-bind="_hs_sliderOpts" v-model="fData.price_hs"></vue-slider>
        </div>



        <!-- Цена за сотку (руб) -->
        <div class="cell" :class="{'xlarge-3 medium-6': filterMode == 'horizontal'}"
          v-if="((fData.estate_type == constants.commerce_land &&
          fData.deal_type == constants.sale) || fData.estate_type == constants.land) &&
          filterMode == 'horizontal'
          ">
          <label>Цена за сотку (руб)</label>
          <div class="grid-x align-middle" ref="price_hs">
            <div class="cell auto"><money v-model="fData.price_hs[0]"></money></div>
            <div class="hyphen shrink">&nbsp;-&nbsp;</div>
            <div class="cell auto"><money v-model="fData.price_hs[1]"></money></div>
          </div>
        </div>



        <div class="cell"
          :class="{'order-last': filterMode == 'vertical'}"
          v-if="fData.estate_group == constants.commerce &&
          fData.estate_type != constants.commerce_land"
        >
          <div class="grid-x gap">
            <div class="cell shrink">
              <checkbox ref="first_line" label="Первая линия" v-model="fData.first_line"></checkbox>
            </div>
            <div class="cell shrink">
              <checkbox ref="individual_entrance" label="Отдельный вход" v-model="fData.individual_entrance"></checkbox>
            </div>
          </div>
        </div>



        <!-- Коммуникации -->
        <portal to="estate_communication" :disabled="( fData.estate_group != constants.cottage )" slim>
          <div class="cell"
            :class="{'xlarge-3 medium-6': filterMode == 'horizontal', 'order-last': filterMode == 'vertical'}"
            v-if="
            fData.estate_type == constants.commerce_land ||
            fData.estate_group == constants.cottage
            "
          >
            <!-- <wrapper-s2m
              label="Коммуникации"
              :options="defaults.estate_communication" v-model="fData.estate_communication"></wrapper-s2m> -->
            <label>Коммуникации</label>
            <select2 ref="estate_communication" multiple
              :options="defaults.estate_communication"
              data-theme="dkm" data-close-on-select="false"
              data-minimum-results-for-search="Infinity"
              data-placeholder="Не важно..."
              v-model="fData.estate_communication"
            >
            </select2>
          </div>
        </portal>

        <!-- <portal-target name="building_material" slim ></portal-target> -->



        <!--
             ###    ########  ########  #### ######## ####  #######  ##    ##    ###    ##
            ## ##   ##     ## ##     ##  ##     ##     ##  ##     ## ###   ##   ## ##   ##
           ##   ##  ##     ## ##     ##  ##     ##     ##  ##     ## ####  ##  ##   ##  ##
          ##     ## ##     ## ##     ##  ##     ##     ##  ##     ## ## ## ## ##     ## ##
          ######### ##     ## ##     ##  ##     ##     ##  ##     ## ##  #### ######### ##
          ##     ## ##     ## ##     ##  ##     ##     ##  ##     ## ##   ### ##     ## ##
          ##     ## ########  ########  ####    ##    ####  #######  ##    ## ##     ## ########

        -->
        <!-- transition-on-mount :min-height="0" unmount-on-hide  -->
        <div class="cell order-last" v-if="fData.estate_group != constants.commerce">
          <collapse-transition>
            <div class="grid-x additional gap" v-show="show_additional">

                <div class="cell"><hr></div>

                <!-- Срок сдачи -->
                <div class="cell" :class="{'xlarge-3 medium-6': filterMode == 'horizontal'}"
                  v-if="fData.estate_group == constants.build"
                >
                  <label>Срок сдачи</label>
                  <fromtoselect2 ref="deadline" v-model="fData.deadline" :options="defaults.deadline"></fromtoselect2>
                </div>

                <!-- Этаж -->
                <portal to="vertical_floor" :disabled="filterMode == 'horizontal'" slim>
                  <div class="cell" :class="{'xlarge-3 medium-6': filterMode == 'horizontal', 'auto': filterMode == 'vertical'}"
                    v-if="
                    in_array(fData.estate_group, [constants.ready, constants.build]) &&
                    fData.estate_type != constants.complex
                    "
                  >
                    <label>Этаж</label>
                    <fromto ref="floor" v-model="fData.floor"></fromto>
                  </div>
                </portal>


                <!-- Этажность -->
                <portal to="vertical_storeys" :disabled="filterMode == 'horizontal'" slim>
                  <portal to="storeys" :disabled="( fData.estate_group != constants.cottage )" slim>
                    <div class="cell" :class="{'xlarge-3 medium-6': filterMode == 'horizontal', 'auto': filterMode == 'vertical'}"
                      v-if="in_array(fData.estate_group, [constants.ready, constants.cottage]) && !in_array(fData.estate_type, [constants.land])"
                    >
                      <label>Этажность</label>
                      <fromto ref="storeys" v-model="fData.storeys"></fromto>
                    </div>
                  </portal>
                </portal>



                <!-- Жилая площадь -->
                <div class="cell" :class="{'xlarge-3 medium-6': filterMode == 'horizontal'}"
                  v-if="
                  in_array(fData.estate_group, [constants.ready, constants.build, constants.cottage])   &&
                  !in_array(fData.estate_type, [constants.complex, constants.land])
                  "
                >
                  <label>Жилая площадь, м²</label>
                  <fromto v-model="fData.living_area"></fromto>
                </div>

                <!-- Площадь кухни -->
                <div class="cell" :class="{'xlarge-3 medium-6': filterMode == 'horizontal'}"
                  v-if="
                  in_array(fData.estate_group, [constants.ready, constants.build, constants.cottage]) &&
                  !in_array(fData.estate_type, [constants.complex, constants.land])
                  "
                >
                  <label>Площадь кухни, м²</label>
                  <fromto ref="kitchen_area" v-model="fData.kitchen_area"></fromto>
                </div>


                <portal-target name="storeys" slim ></portal-target>
                <portal-target name="estate_communication" slim ></portal-target>

                <!-- Класс жилья -->
                <div class="cell" :class="{'xlarge-3 medium-6': filterMode == 'horizontal'}"
                  v-if="
                  fData.estate_group == constants.build ||
                  fData.estate_type == constants.complex
                  "
                >
                  <!-- <wrapper-s2m
                    label="Класс жилья"
                    :options="defaults.estate_class" v-model="fData.estate_class"></wrapper-s2m> -->
                  <label>Класс жилья</label>
                  <select2 ref="estate_class" multiple
                    :options="defaults.estate_class"
                    data-theme="dkm" data-close-on-select="false"
                    data-minimum-results-for-search="Infinity"
                    data-placeholder="Не важно..."
                    v-model="fData.estate_class"
                  >
                  </select2>
                </div>

                <!-- Материал -->
                <!-- <portal to="building_material" :disabled="( fData.estate_group != constants.cottage )" slim> -->
                  <div class="cell" :class="{'xlarge-3 medium-6': filterMode == 'horizontal', 'order-last': filterMode == 'vertical'}"
                    v-if="fData.estate_group != constants.commerce && !in_array(fData.estate_type, [constants.land])"
                  >
                      <!-- <wrapper-s2m
                      label="Материал"
                      :options="defaults.building_material" v-model="fData.building_material"></wrapper-s2m> -->
                      <label>Материал</label>
                      <select2 ref="building_material" multiple
                        :options="defaults.building_material"
                        data-theme="dkm" data-close-on-select="false"
                        data-minimum-results-for-search="Infinity"
                        data-placeholder="Не важно..."
                        v-model="fData.building_material"
                      >
                      </select2>
                  </div>
                <!-- </portal> -->

                <!-- Санузел -->
                <div class="cell" :class="{'xlarge-3 medium-6': filterMode == 'horizontal'}"
                  v-if="
                  in_array(fData.estate_group, [constants.ready, constants.build])
                  &&
                  fData.estate_type != constants.complex
                  "
                >
                  <!-- <wrapper-s2m
                    label="Санузел"
                    :options="defaults.apartment_bathroom" v-model="fData.apartment_bathroom"></wrapper-s2m> -->
                    <label>Санузел</label>
                    <select2 ref="apartment_bathroom" multiple
                      :options="defaults.apartment_bathroom"
                      data-theme="dkm" data-close-on-select="false"
                      data-minimum-results-for-search="Infinity"
                      data-placeholder="Не важно..."
                      v-model="fData.apartment_bathroom"
                    >
                    </select2>
                </div>

                <!-- Отделка -->
                <div class="cell" :class="{'xlarge-3 medium-6': filterMode == 'horizontal'}"
                  v-if="
                  fData.estate_group == constants.build ||
                  fData.estate_type == constants.complex
                  "
                >
                  <!-- <wrapper-s2m
                    label="Отделка"
                    :options="defaults.estate_decoration" v-model="fData.estate_decoration"></wrapper-s2m> -->
                  <label>Отделка</label>
                  <select2 ref="estate_decoration" multiple
                    :options="defaults.estate_decoration"
                    data-theme="dkm" data-close-on-select="false"
                    data-minimum-results-for-search="Infinity"
                    data-placeholder="Не важно..."
                    v-model="fData.estate_decoration"
                  >
                  </select2>
                </div>


            </div>
          </collapse-transition>
        </div>

        <div class="cell order-last ac" v-if="fData.estate_group != constants.commerce">
          <a class="a-extend-filter" @click="show_additional = !show_additional" :class="{'a-extend-filter--active': show_additional}">
            <span v-if="show_additional">скрыть</span> <span>расширенный поиск</span>
          </a>
        </div>



        <div class="cell order-last"><hr></div>


        <!-- искать -->
        <div class="cell order-last ac" :class="{'large-4 large-offset-4': filterMode == 'horizontal'}">
          <button type="submit" class="button button--wayra btn-search">
            <i>
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" preserveAspectRatio="xMidYMid" width="26" height="26" viewBox="0 0 26 26">
                <g fill="#fff">
                  <path d="M25.524,23.226 L19.087,16.780 C20.363,15.035 21.124,12.890 21.124,10.563 C21.124,4.729 16.396,0.000 10.562,0.000 C4.729,0.000 0.000,4.729 0.000,10.563 C0.000,16.396 4.729,21.125 10.562,21.125 C12.895,21.125 15.043,20.360 16.791,19.080 L23.226,25.524 C23.860,26.159 24.889,26.159 25.524,25.524 C26.158,24.889 26.159,23.861 25.524,23.226 ZM3.250,10.563 C3.250,6.524 6.524,3.250 10.562,3.250 C14.601,3.250 17.875,6.524 17.875,10.563 C17.875,14.601 14.601,17.875 10.562,17.875 C6.524,17.875 3.250,14.601 3.250,10.563 Z" />
                </g>
              </svg>
            </i>
            искать
          </button>
        </div>


        <!-- очистить фильтр -->
        <div class="cell order-last ac" :class="{'large-4': filterMode == 'horizontal'}">
          <button type="reset" class="btn-reset-filter" :class="{'float-right': filterMode == 'horizontal'}" id="resetFilter"><i>&times;</i>очистить фильтр</button>
        </div>


      </div>
    </div>

  </form>
</template>

// //
//     ######   ######  ########  #### ########  ########
//    ##    ## ##    ## ##     ##  ##  ##     ##    ##
//    ##       ##       ##     ##  ##  ##     ##    ##
//     ######  ##       ########   ##  ########     ##
//          ## ##       ##   ##    ##  ##           ##
//    ##    ## ##    ## ##    ##   ##  ##           ##
//     ######   ######  ##     ## #### ##           ##
// //

<script>

import vueSlider          from './components/vue2-slider.vue';
import checkbox           from './components/checkbox.vue';
import rooms              from './components/rooms.vue';
import money              from './components/money.vue';
import fromto             from './components/fromto.vue';
import fromtoselect2      from './components/fromtoselect2.vue';
import radio              from './components/radio.vue';
import select2            from './components/select2.vue';
import geo                from './components/geo/geo.vue';


import hint                from './components/hint.vue';



import each               from 'lodash/forEach'
// import debounce           from 'lodash/debounce'
import throttle           from 'lodash/throttle'
import { isEqual }        from 'lodash'
// import isequal            from 'lodash/isequal'
// import _ from 'lodash'
import cloneDeep          from 'lodash/cloneDeep'
import assign             from './assign';
import queryString        from 'query-string';

// DONE: вынести константы и настройки по умолчанию в html объект, чтобы не пересобирать готовое приложение каждый раз
// import {defaults, constants}      from './defaults';


// import {FadeTransition} from 'vue2-transitions'

// import wrapperS2m   from './components/wrapper-s2m.vue';

export default {
  name: 'app',

  components: {
    vueSlider,
    checkbox,
    rooms,
    money,
    fromto,
    fromtoselect2,
    radio,
    select2,
    geo,
    hint,
    // wrapperS2m,
    // FadeTransition,
  },

  beforeCreate () {
    // TODO: change to https://www.npmjs.com/package/vue-fetch with polyfill
    // DONE: вынести адрес в конфиг
    /*
          ######## ########  ######  ##     ##       ########  ######## ##       ########  ######
          ##          ##    ##    ## ##     ##       ##     ## ##       ##          ##    ##    ##
          ##          ##    ##       ##     ##       ##     ## ##       ##          ##    ##
          ######      ##    ##       #########       ##     ## ######   ##          ##     ######
          ##          ##    ##       ##     ##       ##     ## ##       ##          ##          ##
          ##          ##    ##    ## ##     ##       ##     ## ##       ##          ##    ##    ##
          ##          ##     ######  ##     ##       ########  ##       ########    ##     ######
    */
    fetch(_GD.dkf.url.defaults)
      .then(r => r.json())
      .then(json => {
        this.$data.isLoaded = true;
        // mobile slider fix
        setTimeout(() => {
          let papa = this.$el.closest('.b-vertical-filter');
          if (papa) {
            papa.classList.add('inited');
          }
        }, 10);
        // DONE: //NOTE: json reroom
        // initial remember from model
        let _json = this.reArrangeRooms(json);
        this.$data.defaults = assign(this.$data.defaults, _json);
        setTimeout( () => {
          // for RESET
          let initial = this.$browserStore.getLocal('dkf_initial');
          if (initial) {
            this.$data.initial = JSON.parse(initial);
          } else {
            this.$browserStore.setLocal('dkf_initial', JSON.stringify(this.fData));
            this.$data.initial = this.clone(this.$data.fData);
          }
          // triple initial from fdata
          if (this.$data.filterMode == 'vertical') {
            this.$data.initial.deal_type    = this.$data.fData.deal_type;
            this.$data.initial.estate_group = this.$data.fData.estate_group;
            this.$data.initial.estate_type  = this.$data.fData.estate_type;
            this.$browserStore.setLocal('dkf_initial', JSON.stringify(this.$data.initial));
          }
          // await tillall theboogy
          this.readyForLiveSearch = true
        }, 500);
      })
      ;
  },

  created () {

    this.$data.filterMode = _GD.dkf.mode;

    if (this.$data.filterMode == 'horizontal') {
      this.$browserStore.removeLocal('dkf_initial');
      this.$browserStore.removeLocal('dkf_fData');
      // this.$browserStore.clearLocal();
    }

    // DONE: check local storage
    let fData = null;
    if (!_GD.dkf.clear_browserStore) { // если сменили категорию не используем текущий сохраненный в LS фильтр
      fData = this.$browserStore.getLocal('dkf_fData');
    }

    if (fData) {
      this.$data.fData = JSON.parse(fData);
    } else {
      this.$data.fData = this.clone(_GD.dkf.initial);
    }
    this.$data.constants = assign(this.$data.constants, _GD.dkf.constants);
  },

  beforeMount () {
    this.$data.defaults = assign(this.$data.defaults, _GD.dkf.defaults);
    // console.log('defaults', this.$data.defaults);
  },

  // mounted () {
    // this.$data.show_additional = false;
    // this.readyForLiveSearch = true
  // },

  // move to submit

  updated(){

    let changed = !isEqual(this.fData, this.prevfData)

    if (changed && this.readyForLiveSearch) {
      this.prevfData = cloneDeep(this.fData)
      return this.throttledCountResults()
    }
  },

  data() {
    return {

      debug: _GD.dkf.debug,
      // currentEstateGroup: _GD.dkf.estateGroup ? _GD.dkf.estateGroup : null,
      filterMode: 'horizontal',
      show_additional: false,
      isLoaded: false,
      readyForLiveSearch: false,
      localityDataIsLoaded: false,
      // geoPlaceholder: this.initialGeoPlaceholder,
      // initialGeoPlaceholder: 'Введите район, метро, улицу или ЖК',
      geoSelectedString: false,

      countResults: 0,
      tooltipVisibility: false,
      tooltipAutoHide: true,
      tooltipInited: false,

      constants: {},

      fData: {},
      prevfData: {},

      initial: {},
      defaults: {},
      toSend: {},


      geoLists: {}
    }
  },

  watch: {
    'fData.deal_type': function (newVal, oldVal) {
      const estate_type = this.$data.fData.estate_type
      // console.log('estate_type 1', estate_type);
      if (oldVal) {
        let price = this.__nest.price.range;
        this.$data.fData.price = price;
        if (this.__nest.price_sq) {
          let price_sq = this.__nest.price_sq.range;
          this.$data.fData.price_sq = price_sq;
        } else {
          delete  this.$data.fData.price_sq
        }
        if (this.__nest.price_hs) {
          let price_hs = this.__nest.price_hs.range;
          this.$data.fData.price_hs = price_hs;
        } else {
          delete  this.$data.fData.price_hs
        }
        // if (estate_type && estate_type != this.$data.constants.complex) {
        //   setTimeout(() => {
        //     // console.log('estate_type 2', estate_type);
        //     this.$data.fData.estate_type = estate_type
        //   }, 0);
        // }
      }
    },
  },

  computed:{
    __nest:{
      get: function () {
        return this.$data.defaults.price_data[this.$data.fData.deal_type][this.$data.fData.estate_group];
      }
    },

    _sliderOpts:{
      get: function () {
        if (this.__nest[this.$data.fData.estate_type] && this.__nest[this.$data.fData.estate_type].price) {
          return this.__nest[this.$data.fData.estate_type].price.sliderOpts;
        } else {
          return this.__nest.price.sliderOpts;
        }
      }
    },
    // TODO: брать прайс из локалстораж
    _price:{
      get: function () {

        // DONE: брать прайс из локалстораж иначе берем предустановленные значения
        if (this.$data.fData.price.length && this.$data.filterMode == 'vertical') {
          return this.$data.fData.price;
        }

        if (this.__nest[this.$data.fData.estate_type] && this.__nest[this.$data.fData.estate_type].price) {
            let price = this.__nest[this.$data.fData.estate_type].price.range;
            this.$data.fData.price = price;
            return price;
        } else {
          let price = this.__nest.price.range;
          this.$data.fData.price = price;
          return price;
        }
      }
    },

    _price_sq:{ // !commerce_retail && !commerce_land // NOTE:
      get: function () {

        if (this.__nest[this.$data.fData.estate_type] && this.__nest[this.$data.fData.estate_type].price_sq) {
            // let price_sq = this.__nest.price_sq.range;
            let price_sq = this.__nest[this.$data.fData.estate_type].price_sq.range;
            this.$data.fData.price_sq = price_sq;
            return price_sq;
        } else {
            if (this.__nest.price_sq) {
              let price_sq = this.__nest.price_sq.range;
              this.$data.fData.price_sq = price_sq;
              return price_sq;
            }
        }
      }
    },

    _sq_sliderOpts:{
      get: function () {
        if (this.__nest[this.$data.fData.estate_type] && this.__nest[this.$data.fData.estate_type].price_sq) {
          return this.__nest[this.$data.fData.estate_type].price_sq.sliderOpts;
        } else {
          if (this.__nest.price_sq) {
            return this.__nest.price_sq.sliderOpts;
          }
        }
      }
    },

    _price_hs:{
      get: function () {
        if (this.__nest.price_hs) {
          let price_hs = this.__nest.price_hs.range;
          this.$data.fData.price_hs = price_hs;
          return price_hs;
        }
      }
    },

    _hs_sliderOpts:{
      get: function () {
        if (this.__nest.price_hs) {
          return this.__nest.price_hs.sliderOpts;
        }
      }
    },

    geoPlaceholder:{
      get: function () {
        if (!this.$data.fData.geo || !this.$data.fData.geo.length) {
          return this.initialGeoPlaceholder
        }
        return this.geoSelectedString
      },
      set: function (newValue) {
        // ...
      }
    },
    initialGeoPlaceholder:{
      get: function () {
        // HACK: hardcode placeholder
        // TODO: исключать метро при выборе коттедж очищать выбор в целом?
        if (this.$data.fData.estate_group == this.$data.constants.cottage) {
          return 'Введите название поселка, улицы, района'
        }
        return 'Введите название ЖК, улицы, район или метро'
      },
      set: function (newValue) {
      }
    }
  },

  methods: {

    // debounce(f){
    //   debounce(f);
    // },

    tooltipHide(toggle){
      this.tooltipAutoHide = !toggle
      this.tooltipVisibility = toggle
    },

    throttledCountResults: throttle( function() {
        this.submitAjax()
      }, 300,{
        'leading': false,
        'trailing': true
      }),

    reArrangeRooms(json){
      let _apartment_room_map = [1,2,3,4,5,6];
      let _cottage_room_map = [3,4,5,10,11,12]; // TODO: hardcoded IDs Количество комнат
      let apartment_room = [];
      let cottage_room = [];

      each(json.apartment_room, (item) => {
          if (this.in_array(item.id, _apartment_room_map)) {
            apartment_room.push(item);
          }
          if (this.in_array(item.id, _cottage_room_map)) {
            cottage_room.push(item);
          }
      });

      // console.log('_apartment_room', apartment_room);
      // console.log('_cottage_room', cottage_room);

      json = assign(json, {'apartment_room': apartment_room});
      json = assign(json, {'cottage_room': cottage_room});

      return json;
    },

    fetchLocalityData(callback){
      // DONE: clear geo on locality change
      if (this.$refs.geo) {
        this.$refs.geo.clear();
      }
      // TODO: implement localstorage to save geo lists - cache
      fetch(_GD.dkf.url.locality + '?locality=' + this.$data.fData.locality + '&estate_group=' + this.$data.fData.estate_group)
      // fetch('./locality_data' + this.$data.fData.locality + '.json')
        .then(r => r.json())
        .then(json => {
          this.$data.localityDataIsLoaded = true;
          this.$data.geoLists = json;
          // seed initial geos
          if (typeof callback == 'function') {
            callback()
          }
        })
        ;
    },

    dealFilterToPropertyKind(data) {
      if (!data) {
        return [];
      }
      var vm = this;
      if (vm.$data.constants.rent == vm.$data.fData.deal_type){
        let _data = data.filter(
          function(item, index) {
            if (item.id != vm.$data.constants.build) {
              return item;
            }
          }
        );
        // console.log('_data', );
        if ( this.fData.estate_group == this.constants.build ) {
          this.fData.estate_group = this.constants.ready
        }
        return _data;
      }
      return data;
    },

    dealFilterToPropertyType(data) {

      if (!data) {
        return [];
      }
      var vm = this;
      if (vm.$data.constants.rent == vm.$data.fData.deal_type){

        let _data = data.filter(
          function(item, index) {
            // if(vm.$data.constants.commerce == vm.$data.fData.estate_group && item.id != vm.$data.constants.commerce_land){ }
            if (item.id != vm.$data.constants.complex && item.id != vm.$data.constants.village && item.id != vm.$data.constants.commerce_land && item.id != vm.$data.constants.land) {
              return item;
            }
          }
        );
        // return _data.reverse();
        return _data;
      }
      return data;
    },

    in_array(needle, haystack){
      for(var i in haystack) {
          if(haystack[i] == needle) return true;
      }
      return false;
    },

    clone(from){
      return JSON.parse(JSON.stringify(from));
    },

    reset() {
      this.$data.fData = this.clone(this.$data.initial);

      // assign seected (inited) geos after list updates
      this.$data.localityDataIsLoaded = false;
      this.fetchLocalityData(() => {
        if (this.$data.initial.geo) {
          this.$data.fData.geo =  this.clone(this.$data.initial.geo);
        }
      });
    },

    preSubmit(){

       // save for inner on submit
        this.$browserStore.setLocal('dkf_fData', JSON.stringify(this.$data.fData));

        let toSend = {};

        if (this.$refs) {
          each(this.$refs, (val, key) => {
            console.log('key', key);
            var data = cloneDeep(this.fData[key]);
            if (key == 'geo') {
              data = JSON.stringify(this.fData[key])
            }
            toSend[key] = data;
          });
        }

        console.log("toSend", toSend);
        var _queryString = queryString.stringify(toSend, {arrayFormat: 'index'});
        console.log(_queryString);
        return _queryString;
    },

  	submitAjax() {
      if (this.tooltipInited) {
        let _queryString = this.preSubmit();
        let data = new FormData();
            data.append( 'dkfilter', _queryString );
        (async () => {
          const rawResponse = await fetch('/catalog/ajax', {
            method: 'POST',
            // body: JSON.stringify({a: 1, b: 'Textual content'})
            body: data
          });
          const content = await rawResponse.json();
          this.countResults = content
          this.tooltipVisibility = true
          setTimeout(() => {
            if (this.tooltipAutoHide) {
              this.tooltipVisibility = false
            }
          }, 1500);
          console.log(content);
        })();
      } else {
        this.tooltipInited = true
      }
    },

  	submit() {

      let _queryString = this.preSubmit();

      // var _queryString_parsed = queryString.parse(_queryString);
      // console.log('_queryString_parsed', _queryString_parsed);

      // if (_queryString_parsed.geo) {
      //   console.log('_queryString_parsed_GEO', JSON.parse(_queryString_parsed.geo));
      // }
      let query_string = (_GD.dkf.filter_query_string) ? _GD.dkf.filter_query_string.replace(/^\//,'') : window.location.search
      // console.log('window.location.search', window.location.search);
      // console.log('query_string', query_string);
      var form          = document.createElement("form");
          form.method   = "POST";
          // form.action   = '/catalog' + window.location.search.replace(/((\/?\?)|(&))?page=\d+/gi,'');
          form.action   = '/catalog' + query_string;

      var element       = document.createElement("input");
          element.type  = "hidden";
          element.value = _queryString;
          element.name  = 'dkfilter';
          form.appendChild(element);
        // each(_queryString_parsed, (val, key) => {
        //   console.log('key', key);
        //   console.log('val', val);
        //   let element;
        //       element = document.createElement("input");
        //       element.type = "hidden";
        //       element.value = val;
        //       element.name = key;
        //   form.appendChild(element);
        // });

        document.body.appendChild(form);
        form.submit();

        // console.log('jq',$.param(toSend));
        // console.log('parse',queryString.parse($.param(toSend)));

        // var data = JSON.stringify(this.fData, null, ' ');
        // var data = JSON.stringify(this.fData);
        // console.log("this.fData", this.fData);
        // console.log("data", data);
        // var data = this.fData;
        // // TODO: change
        // var toSendShema = this.toSendShema[data.deal_type];// !!!!!!!!!!!!!!!!!!!!!!!!
        // var _toSend = {};
        //
        // toSendShema.map(function(key) {
        //         if (data[key]) {
        //             _toSend[key] = data[key];
        //         }
        //     }
        // );
        //
        // this.toSend = _toSend;
    	// alert(JSON.stringify(toSend, null, ' '))
    }
  }
}
</script>

// //
//     ######  ######## ##    ## ##       ########  ######
//    ##    ##    ##     ##  ##  ##       ##       ##    ##
//    ##          ##      ####   ##       ##       ##
//     ######     ##       ##    ##       ######    ######
//          ##    ##       ##    ##       ##             ##
//    ##    ##    ##       ##    ##       ##       ##    ##
//     ######     ##       ##    ######## ########  ######
// //

<style lang="scss">
  // @import './assets/css/main.css';
  @import './../../../../_2017/dk/www/html/css/scss/breakpoints';

  .button.btn-search{
    display: inline-block;
    width: auto !important;

    margin-top: 20px;
    padding: 9px 40px 5px;
    background-color: #ff6659;
    border: 1px solid #ff6659;
    color: #fff;
    .b-vertical-filter & {
      width: 100% !important;
      display: block;
      height: 40px;
      padding: 3px 0 0;
    }
    i{
        display: inline-block;
        vertical-align: middle;
        svg{
          .b-vertical-filter & {
            width: 20px;
            height: 20px;
          }
        }
    }
  }

  .select2-container--dkm,
    .select2-container--dk{
      .select2-results__options{
        .select2-results__option{
          line-height: 1;
          display:flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
        }
      }
    }


  .b-filter {

    position: relative;

    .order-last{
      order: 20;
    }

    // hr{
    //   margin-top: 15px;
    // }
    // .additional {
    //    hr{
    //     margin-top: 25px;
    //   }
    // }

    &__wrapper{
      background: #ffffff;
      display: flex;
      flex-direction: row;
      justify-content: center;

      // width: calc(100% + 30px);
      // margin-left: -15px;
      @include breakpoint(medium down) {
        .grid-x.gap > .cell{
          padding-left: 5px;
          padding-right: 5px;
          & > .grid-x.gap{
            margin-left: -5px;
            margin-right: -5px;
          }
        }
      }
      @include breakpoint(large) {
        .grid-x.gap > .cell{
          padding-left: 10px;
          padding-right: 10px;
          & > .grid-x.gap{
            margin-left: -10px;
            margin-right: -10px;
          }
        }
      }
    }

    &__controls{
      // background: #fff;
      // padding: 5px 25px 25px;
      padding-bottom: 25px;
      max-width: 1080px;
      @include breakpoint(large down) {
        width: 620px;
        margin-right: auto;
        margin-left: auto;
      }
      @include breakpoint(medium down) {
        width: 440px;
        margin-right: auto;
        margin-left: auto;
      }
      @include breakpoint(479px down) {
        width: 280px;
        margin-right: auto;
        margin-left: auto;
      }

      label{
        color: #6c7880;
        font-size: 14px;
        font-weight: 400;
        display: block;
        padding: 20px 0 0;
        &.ac{
          width: 100%;
        }
      }

      .cell{
        position: relative;
        & > label{
          .b-vertical-filter & {
            text-align: center;
          }
        }
      }

      input{
        font-size: 14px;
        padding: 10px 7px;
      }

      select{
        width: 100%;
      }
      .select2-container--dk{
        width: 100% !important;
      }
      .select2-container--dkm{
        // for hidden fields
        width: 100% !important;
        .select2-search__field{
          width: 100% !important;
        }

        .select2-search.select2-search--inline{
          position: absolute;
          input{
            pointer-events: none;
          }
        }
      }
    }

    .a-extend-filter {
      color: #9c9d9e;
      font-size: 10px;
      font-weight: 900;
      line-height: 25px;
      text-decoration: underline;
      text-transform: uppercase;
      display: inline-block;
      margin-top: 25px;
      margin-bottom: -15px;
      cursor: pointer;
      position: relative;
      z-index: 1;
      padding-bottom: 7px;
      // &:hover span,
      // &:hover {
      //   color: #ff6659;
      // }
      @include breakpoint(medium down) {
        padding: 7px 40px 3px;
      }
      &:after{
        content: "";
        background-image: url("data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHdpZHRoPSIxMS44MTJweCIgaGVpZ2h0PSI2Ljk0cHgiIHZpZXdCb3g9IjAgMCAxMS44MTIgNi45NCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMTEuODEyIDYuOTQiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8ZyBmaWxsPSIjOWM5ZDllIj4KCTxwYXRoIGQ9Ik01Ljg5Nyw2LjkzNWMtMC4yNTMsMC0wLjUwNS0wLjA5Ny0wLjY5OC0wLjI5TDAuMjY4LDEuNjk5Yy0wLjM4NS0wLjM4Ni0wLjM4NS0xLjAxMywwLTEuMzk5CgkJYzAuMzg2LTAuMzg3LDEuMDEtMC4zODcsMS4zOTUsMGw0LjIzNCw0LjI0N0wxMC4xMzEsMC4zYzAuMzg1LTAuMzg3LDEuMDA5LTAuMzg3LDEuMzk0LDBjMC4zODUsMC4zODYsMC4zODUsMS4wMTMsMCwxLjM5OQoJCUw2LjU5NCw2LjY0NUM2LjQwMSw2LjgzOCw2LjE0OSw2LjkzNSw1Ljg5Nyw2LjkzNXoiLz4KPC9nPgo8L3N2Zz4=");
        background-position: 50% 50%;
        background-size: contain;
        background-repeat: no-repeat;
        width: 12px;
        height: 6px;
        position: absolute;
        display: block;
        bottom: 0;
        left: 50%;
        margin-left: -6px;
      }
      &--active{
        padding-bottom: 0;
        padding-top: 7px;
        &:after{
          transform: scale(-1);
          bottom: auto;
          top: 0;
        }
      }
    }

    .btn-reset-filter {
      color: #a6adb1;
      font-size: 10px;
      font-weight: 900;
      line-height: 25px;
      text-decoration: underline;
      text-transform: uppercase;
      display: inline-block;
      margin-top: 30px;
      cursor: pointer;
      @include breakpoint(medium down) {
        margin-top: 15px;
        &.float-right{
          float: none !important;
        }
      }
      i {
        display: inline-block;
        margin-right: 6px;
        vertical-align: middle;
        border-radius: 50%;
        border-width: 1px;
        border-color: #9c9c9c;
        border-style: solid;
        background-color: #fff;
        font-size: 12px;
        line-height: 12px;
        font-weight: 700;
        width: 14px;
        height: 14px;
      }
      &:hover {
        color: #ff6659;
        i {
          color: #ff6659;
          border-color: #ff6659;
        }
      }
    }



    .vue-slider-component {
      margin-top: 12px;
      .vue-slider {
        background-color: rgb(235, 236, 237) !important;
        position: relative;
        &:after,
        &:before {
          content: "";
          display: inline-block;
          position: absolute;
          z-index: 0;
          height: 4px;
          width: 16px;
          border-radius: 15px;
          background-color: rgb(235, 236, 237);
        }
        &:before {
          left: -8px;
          width: 16px;
        }
        &:after {
          left: auto;
          width: 16px;
          right: -8px;
        }
      }
      .vue-slider-process {
        background-color: #ff6659 !important;
        z-index: 1;
      }
    }

    input[type=checkbox] {
        & ~ i img[src$=".svg"] {
            visibility: visible;
        }
        & ~ i svg {
            visibility: visible;
        }
    }
    input[type=radio] {
      -webkit-appearance: radio;
      width: auto;
    }
    .select2-selection__clear {
      position: absolute !important;
      right: -10px;
    }
  }







  [v-cloak] {
      display: none;
  }


</style>



// WEBPACK FOOTER //
// src/Dkfilter.vue